import { createSlice } from "@reduxjs/toolkit";

const reviewQueueSlice = createSlice({
  name: "reviewQueue",
  initialState: {
    items: [],
    total: 0,
    openCount: 0,
    selectedItem: null,
    loading: false,
    error: null,
    filters: {
      assessmentId: null,
      status: null,
      source: null,
    },
    page: 1,
    limit: 20,
  },
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    setItems: (state, action) => {
      const data = action.payload;
      state.items = data.items || data;
      state.total = data.total || (data.items || data).length;
      state.loading = false;
      state.error = null;
    },
    setOpenCount: (state, action) => {
      state.openCount = action.payload;
    },
    setSelectedItem: (state, action) => {
      state.selectedItem = action.payload;
    },
    clearSelectedItem: (state) => {
      state.selectedItem = null;
    },
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
      state.page = 1;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    updateItemStatus: (state, action) => {
      const { id, status, resolution } = action.payload;
      const item = state.items.find(i => i._id === id);
      if (item) {
        item.status = status;
        if (resolution) item.resolution = resolution;
      }
      if (status === 'resolved' || status === 'dismissed') {
        state.openCount = Math.max(0, state.openCount - 1);
      }
    },
  },
});

export const {
  setLoading, setError, setItems, setOpenCount, setSelectedItem,
  clearSelectedItem, setFilters, setPage, updateItemStatus,
} = reviewQueueSlice.actions;

export default reviewQueueSlice.reducer;
